import { useMutation, UseMutationOptions } from 'react-query';
import { AxiosError } from "axios";

import request from "common/request";

type LogoutMutationVariable = {
  medium?: string | null;
};

export const usePostComplete = (
  options?: UseMutationOptions<any, AxiosError, LogoutMutationVariable>
) => {
  return useMutation<any, AxiosError, LogoutMutationVariable>(
    async ({ medium}) => {
      try {
        const response = await request.post('/signup/complete', {
          medium,
        });
        
        return response
      } catch(e){
        //@ts-ignore
        // console.log(e)
      }
    },
    {
      ...options
    }
  )
}

export default usePostComplete;